// extracted by mini-css-extract-plugin
module.exports = {"footerSeo":"_1QILC"};